import { ApolloError } from "@apollo/client/core";
import { GraphQLErrorCode } from "@/core/api/graphql/enums";
import { hasErrorCode } from "@/core/api/graphql/utils";
import { useNotifications } from "@/shared/notification/composables/useNotifications";

// Shows the backend rejection message when an order is refused because its cart is still in BRL.
// Returns true when the error was a BRL rejection and has been reported to the user.
export const notifyBrlCurrencyOrderError = (error: unknown): boolean => {
  if (
    !(error instanceof ApolloError) ||
    !hasErrorCode(error.graphQLErrors, GraphQLErrorCode.BrlCurrencyNoLongerSupported)
  ) {
    return false;
  }

  const message = error.graphQLErrors
    .filter(({ extensions }) => extensions?.code === GraphQLErrorCode.BrlCurrencyNoLongerSupported)
    .map(({ message: errorMessage }) => errorMessage)
    .join("\n");

  useNotifications().error({ text: message, duration: 15000, single: true });
  return true;
};
